"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * MobileNavLink Component.
 *
 * A clickable anchor link component optimized for mobile navigation.
 * Provides simplified styling and behavior compared to desktop navigation links.
 *
 * @param {Object} props React props
 * @param {String} props._name Link Tracking name
 * @param {String} props.href Anchor href
 * @param {String} props.title Anchor Title
 * @param {Boolean} props.active Link active state
 * @param {String} props.anchorId Anchor section id
 * @param {Function} props.scrollToAnchor Onclick event to scroll to anchor
 * @returns {React.ReactElement} MobileNavLink Component
 * @public
 */

function MobileNavLink({
  _name,
  href,
  title,
  active,
  anchorId,
  scrollToAnchor,
  target,
  rel
}) {
  const ref = (0, _react.useRef)(null);
  _patternLibraryUtils.tracking.useTracking(ref);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, true, false);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    _react.default.createElement("a", (0, _extends2.default)({
      className: "mobile-nav-link",
      ref: ref,
      "data-cy": "mobile-nav-link",
      href: anchorId ? '#' : href
    }, anchorId ? {
      'data-target': anchorId,
      'onClick': scrollToAnchor
    } : {}, {
      "data-active": active,
      target: target,
      rel: rel
    }, trackingProps), title)
  );
}
var _default = exports.default = MobileNavLink;
MobileNavLink.propTypes = {
  _name: _propTypes.default.string,
  href: _propTypes.default.string,
  title: _propTypes.default.string,
  active: _propTypes.default.bool,
  anchorId: _propTypes.default.string,
  scrollToAnchor: _propTypes.default.func,
  target: _propTypes.default.string,
  rel: _propTypes.default.string
};